export enum GGNotificationTypeEnum {
    INIZIALE = 'INIZIALE',
    RICONFERMA_ANNUALE = 'RICONFERMA_ANNUALE',
    ESTENSIONE = 'ESTENSIONE',
    MODIFICA_DATI_ANAGRAFICI = 'MODIFICA_DATI_ANAGRAFICI',
    ALTRO = 'ALTRO'
}

export enum GGStandardEnum {
    IFA = 'IFA',
    CoC = 'CoC'
}

export enum StandardSubfieldEnum {
    NESSUNO = 'NESSUNO',
    FV = 'FV',
    FO = 'FO'
}

export enum StandardOptionEnum {
    IFA_OPZIONE_1_PRODUTTORE_SITO_SINGOLO = 'IFA_OPZIONE_1_PRODUTTORE_SITO_SINGOLO',
    IFA_OPZIONE_1_PRODUTTORE_MULTISITO_SENZA_SGQ = 'IFA_OPZIONE_1_PRODUTTORE_MULTISITO_SENZA_SGQ',
    IFA_OPZIONE_1_PRODUTTORE_MULTISITO_CON_SGQ = 'IFA_OPZIONE_1_PRODUTTORE_MULTISITO_CON_SGQ',
    IFA_OPZIONE_2_CERTIFICAZIONE_DI_GRUPPO = 'IFA_OPZIONE_2_CERTIFICAZIONE_DI_GRUPPO',
    COC_OPZIONE_1_CERTIFICAZIONE_INDIVIDUALE = 'COC_OPZIONE_1_CERTIFICAZIONE_INDIVIDUALE',
    COC_OPZIONE_1_SITI_SINGOLI = 'COC_OPZIONE_1_SITI_SINGOLI',
    COC_OPZIONE_1_MULTISITO = 'COC_OPZIONE_1_MULTISITO',
    COC_OPZIONE_1_MULTISITO_PER_NEGOZI_AL_DETTAGLIO_E_CATENE_DI_RISTORANTI_IN_FRANCHISING = 'COC_OPZIONE_1_MULTISITO_PER_NEGOZI_AL_DETTAGLIO_E_CATENE_DI_RISTORANTI_IN_FRANCHISING'
}

export enum ValutationResultEnum {
    PRATICA_COMPLETATA = 'PRATICA_COMPLETATA',
    PRATICA_NON_COMPLETA = 'PRATICA_NON_COMPLETA'
}

export interface GGNotificationUpdateDTO {
    customerId?: string
    entryProtocolId?: string
    type?: GGNotificationTypeEnum
    otherType?: string
    standard?: GGStandardEnum
    standardSubfield?: StandardSubfieldEnum
    standardOption?: StandardOptionEnum
    graspModule?: boolean
    coopModule?: boolean
    springModule?: boolean
    valutationDate?: Date
    valutationResult?: ValutationResultEnum
    valutationNote?: string
    manipulationSoldProducts?: boolean
    manipulationPostHarvesting?: boolean
    manipualtionInnerStructures?: boolean
    manipulationOtherStructuresNoGG?: boolean
    manipulationOtherStructuresGGWithGGN?: boolean
    manipulationExtraFarmProducts?: boolean
}

export interface GGNotificationDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    entryProtocolId: string
    entryProtocolInfo: string
    type: GGNotificationTypeEnum
    otherType: string
    standard: GGStandardEnum
    standardSubfield: StandardSubfieldEnum
    standardOption: StandardOptionEnum
    graspModule: boolean
    coopModule: boolean
    springModule: boolean
    valutationDate: Date
    valutationResult: ValutationResultEnum
    valutationNote: string
    customerId: string
    manipulationSoldProducts: boolean
    manipulationPostHarvesting: boolean
    manipualtionInnerStructures: boolean
    manipulationOtherStructuresNoGG: boolean
    manipulationOtherStructuresGGWithGGN: boolean
    manipulationExtraFarmProducts: boolean
}

export interface GetAllGGNotificationDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: GGNotificationDTO[]
}

export interface GetAllGGNotificationFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    customerId?: string
}